module.exports = __webpack_public_path__ + "media/images/lupa-d6647f8d8f82bbe29e65624469c5f1c7.svg";